<template>
  <div>
    <div class="text-center q-mb-md">
      <q-btn
        :to="{ name: 'app.settings.timeline' }"
        label="Go to timeline"
        no-caps
      />
    </div>
    <div>
      <q-search
        v-model.lazy="searchQuery"
        inverted
        color="secondary"
        stack-label="Search"
        placeholder="default activation fee..."
        @input="fetchSettings"
      />
    </div>
    <div class="row gutter-md">
      <SettingCategories
        v-if="settings.length"
        :settings="settings"
        @filter="filterByCategory"
      />
      <q-list
        class="col-md-10"
        no-border
        separator
        sparse
      >
        <q-item
          v-for="setting in filteredSettings"
          :key="setting.id"
        >
          <q-item-main>
            <SettingRow
              :setting="setting"
              :editable="hasEditPermission"
              with-children
            />
          </q-item-main>
        </q-item>
      </q-list>
      <bj-inner-loading :visible="loading" />
    </div>
  </div>
</template>

<script>
import SdTimeline from '../../components/timeline';
import SettingRow from '../../components/setting-row';
import SettingCategories from '../../components/settings-categories';

export default {
  components: {
    SettingRow,
    SdTimeline,
    SettingCategories,
  },
  data() {
    return {
      settings: [],
      filteredSettings: [],
      loading: true,
      hasEditPermission: false,
      searchQuery: '',
      selectedCategory: null,
    };
  },
  created() {
    if (this.userRoleIs(this.$config.roles.SUPER_ADMIN)) {
      this.hasEditPermission = true;
    }
    this.fetchSettings();
  },
  methods: {
    fetchSettings() {
      this.loading = true;
      this.api().request('GET', `settings/${this.searchQuery}`, {}, {
        is_overrideable: false,
      }).then((settings) => {
        this.settings = settings;
        this.filterByCategory(this.selectedCategory);
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.uiNotify('Error occurred', 'negative');
      });
    },
    filterByCategory(category) {
      this.selectedCategory = category;
      this.filteredSettings = this.settings.filter((setting) => (!category ? true : setting.category === category));
    },
  },
};

</script>
